exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".wrapped[data-v-0a857330]{width:100%;padding:0 5px}.wrapped .row[data-v-0a857330]{height:110px;background-color:#f5f5f5}.wrapped .row .descrizione[data-v-0a857330]{text-transform:lowercase}.wrapped .row .descrizione[data-v-0a857330]:first-letter{text-transform:uppercase}", ""]);

// exports
